import React from 'react'; 
import { Link } from "react-router-dom";

const Sixthgrade_k6_subjects = () => { 
  const subjects = [
    { 
      id: 'english', 
      name: 'English Language Arts', 
      icon: '📖', 
      borderColor: 'border-purple-500 hover:bg-purple-50/50', 
      path: '/learning/sixthgrade_k6/sixthgrade_k6eng' 
    },
    { 
      id: 'math', 
      name: 'Mathematics', 
      icon: '📐', 
      borderColor: 'border-blue-500 hover:bg-blue-50/50', 
      path: '/learning/sixthgrade_k6/sixthgrade_k6math' 
    },
    { 
      id: 'science', 
      name: 'Science', 
      icon: '🔬', 
      borderColor: 'border-green-500 hover:bg-green-50/50', 
      path: '/learning/sixthgrade_k6/sixthgrade_k6scie' 
    },
    { 
      id: 'social', 
      name: 'Social Studies', 
      icon: '🌍', 
      borderColor: 'border-yellow-500 hover:bg-yellow-50/50', 
      path: '/learning/sixthgrade_k6/sixthgrade_k6soc' 
    },
  ];
  return ( 
   <div className="w-full">
      {/* Header */}
      <div className="mb-10 border-b pt-24">
        <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight">Grade Six Class</h1>
        <p className="text-gray-500 mt-2">Select a subject card below to open its dedicated learning and assessment page.</p>
      </div>

      {/* Tailwind Grid Container */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {subjects.map((subject) => (
          <Link 
            key={subject.id}
            to={subject.path}
            className={`p-6 bg-white rounded-2xl shadow-sm border-t-4 ${subject.borderColor} transition-all duration-300 transform hover:-translate-y-1 hover:shadow-md flex flex-col items-center justify-center text-center h-52 group`}
          >
            {/* Hover-animated Icon */}
            <span className="text-5xl mb-4 transition-transform duration-300 group-hover:scale-110">
              {subject.icon}
            </span>
            
            {/* Subject Name */}
            <h2 className="text-xl font-bold text-gray-800">{subject.name}</h2>
            
            {/* Action Tip */}
            <span className="text-xs font-medium text-blue-600 mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              Open Page →
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
export default Sixthgrade_k6_subjects;